import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import {Observable} from "rxjs";
import {HttpHeaders} from "@angular/common/http";
import {Channel} from "../../models/channel";

export class ChannelDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.CHANNELS, apiHelper);
    }

    public getActiveChannels(publicId?: string): Observable<Channel[]> {
        const url: string = this.apiHelper.getServiceName() + this.getResource() + '/get/active';
        let headers: HttpHeaders;
        if (publicId) {
            headers = this.apiHelper.getChangeManagementPublicHeaders(publicId)
        } else {
            headers = this.apiHelper.getDefaultHeader();
        }
        return this.apiHelper.apiCall(url, 'GET', null, null, headers);
    }
}